import React from 'react';
import ErrorScreen from './ErrorScreen';

/**
 * Captura errores de render de React no controlados (la causa real de las
 * "pantallas en blanco") y muestra una ErrorScreen con salidas en lugar de
 * dejar la app rota. Es un class component porque los error boundaries solo
 * pueden implementarse con la API de clases.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // En producción esto puede enviarse a un servicio de monitoreo.
    console.error('ErrorBoundary capturó un error:', error, info);
  }

  handleRetry = () => {
    // Reintenta el render limpiando el estado; si persiste, recarga.
    this.setState({ hasError: false });
  };

  handleBack = () => {
    this.setState({ hasError: false });
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.assign((process.env.PUBLIC_URL || '') + '/');
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorScreen
          onRetry={() => window.location.reload()}
          onBack={this.handleBack}
        />
      );
    }
    return this.props.children;
  }
}
